/* eslint-disable no-console */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/prefer-default-export */
import React, { useState, useCallback, useEffect } from 'react'
import s from './Collaborators.module.css'

export function Collaborators({ id, onClose }) {
  const [inProgress, setInProgress] = useState(false)
  const [emailToInvite, setEmailToInvite] = useState('')
  const [existingCollaborators, setExistingCollaborators] = useState([])

  useEffect(() => {
    async function getCollaborators() {
      try {
        const apiToken = localStorage.getItem('apiToken')

        const response = await fetch(`/api/v3/listing_collections/${id} `, {
          headers: {
            'API_TOKEN': apiToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })

        const data = await response.json()

        if (data.shared_with_contacts) {
          setExistingCollaborators(data.shared_with_contacts)
        }
        // eslint-disable-next-line no-console
        console.log(data)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    }

    getCollaborators()
  }, [id, inProgress])

  const handleInvite = useCallback(async () => {
    try {
      setInProgress(true)
      const apiToken = localStorage.getItem('apiToken')
      const formData = new FormData()

      const sharedEmails = [
        ...existingCollaborators,
        {
          value: emailToInvite?.trim(),
          type: 'email',
        },
      ]

      sharedEmails.forEach((contactItem, index) => {
        formData.append(`listing_collection[shared_with_contacts][${index}][type]`, contactItem.type)
        formData.append(`listing_collection[shared_with_contacts][${index}][value]`, contactItem.value)
      })

      const response = await fetch(`/api/v3/listing_collections/${id}`, {
        headers: {
          API_TOKEN: apiToken,
        },
        method: 'PUT',
        body: formData,
      })

      const data = await response.json()
      // eslint-disable-next-line no-console
      console.log(data)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setInProgress(false)
    }
  }, [existingCollaborators, emailToInvite])

  const handleRemove = useCallback(
    async (collaborator) => {
      // Убрать лишнюю вложенность
      try {
        setInProgress(true)
        const apiToken = localStorage.getItem('apiToken')
        const formData = new FormData()

        const sharedEmails = existingCollaborators.filter(
          (existingCollaborator) => existingCollaborator.value !== collaborator.value
        )

        sharedEmails.forEach((contactItem, index) => {
          formData.append(`listing_collection[shared_with_contacts][${index}][type]`, contactItem.type)
          formData.append(`listing_collection[shared_with_contacts][${index}][value]`, contactItem.value)
        })

        const response = await fetch(`/api/v3/listing_collections/${id}`, {
          headers: {
            API_TOKEN: apiToken,
          },
          method: 'PUT',
          body: formData,
        })

        const data = await response.json()
        console.log(data)
      } catch (error) {
        console.error(error)
      } finally {
        setInProgress(false)
      }
    },
    [existingCollaborators, id]
  )

  return (
    <div className={s.root}>
      <div className={s.title}>Collaborators</div>

      <label className={s.label} htmlFor="email">
        Add Email
      </label>
      <input
        className={s.input}
        type="email"
        id="email"
        value={emailToInvite}
        autoComplete="off"
        placeholder="Email"
        onChange={(e) => {
          const { value } = e.target
          setEmailToInvite(value)
        }}
      />

      <div className={s.controls}>
        <button type="button" className={s.invite} disabled={inProgress} onClick={handleInvite}>
          {inProgress ? 'Updating...' : 'Invite'}
        </button>
      </div>

      <div className={s.existingCollaborators}>
        <div className={s.existingCollaboratorTitle}>Existing Collaborators</div>

        {existingCollaborators
          ?.filter((item) => item.type === 'email')
          .map((collaborator) => (
            <div className={s.existingCollaborator} key={collaborator.value}>
              <div className={s.existingCollaboratorName}>{collaborator.value}</div>

              <div className={s.existingCollaboratoControls}>
                {/* <button type="button" className={s.button}>
                  Add
                </button> */}
                <button type="button" className={s.button} onClick={() => handleRemove(collaborator)}>
                  Remove
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}
